import { OnInit } from '@angular/core';
import { Campaign, CampaignSection } from '../_models';
import { AlertService, CampaignService, LoaderService, SideNavService } from '../_services';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { CrudSaveComponent } from '../_directives';

export abstract class CampaignSettingsAbstractComponent extends CrudSaveComponent implements OnInit {
  public section = CampaignSection.General;
  public campaign: Campaign = null;

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected campaignService: CampaignService,
    protected sideNav: SideNavService,
    protected alertService: AlertService,
    protected loaderService: LoaderService
  ) {
    super(router, location, route, campaignService, alertService);
    this.isNew = false;
    this.isPartial = true;
    this.objectName = 'brand';
    this.sideNav.setSideNavExpanded(false);
  }

  ngOnInit() {
    super.ngOnInit();
    this.campaign = this.campaignService.getCurrentCampaign();
    this.id = this.campaign.id;
    this.onCampaignFetch(this.campaign);
  }

  onCampaignFetch(data: Campaign) {
    this.form.patchValue(data);
  }

  onSubmit() {
    this.submitted = true;

    if (this.form.valid) {
      this.loaderService.show();
      super.onSubmit();
    }
  }

  protected onSaveComplete(data) {
    data = { ...this.campaign, ...data };
    this.campaign = data;
    this.loaderService.hide();
  }

  copyToClipboard(text: string) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.alertService.success('Copied to clipboard');
      })
      .catch((err) => {
        this.alertService.error('Failed to copy text');
      });
  }

  protected handleSubmitError(error: any, keepAfterNavigationChange: boolean = false, showAlert: boolean = false) {
    super.handleSubmitError(error, keepAfterNavigationChange, showAlert);
    this.loaderService.hide();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.sideNav.setSideNavExpanded(true);
  }
}
